import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { getSettings } from "../api";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/why-sscreadymix", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/works", label: "Projects" },
  {to:"/quality", label:"Quality"},
  { to: "/gallery", label: "Gallery" },
  { to: "/diy", label: "Calculator" },
  
  { to: "/blogs", label: "Insights" },
  { to: "/faq", label: "FAQ" },
  {to:"/careers", label:"Careers"},
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [settings, setSettings] = useState({});
  const loc = useLocation();

  useEffect(() => { getSettings().then(setSettings); }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setOpen(false); window.scrollTo(0,0); }, [loc.pathname]);

  return (
    <>
      {/* Top bar */}
      <div className="hidden md:block bg-white border-b border-[#ececef] text-[12px] text-gray-500">
        <div className="max-w-[1500px] mx-auto px-6 h-9 flex items-center justify-between">
          <span className="font-mono">{settings.top_bar_text || "SSC · READY MIX CONCRETE · ENGINEERED FOR STRENGTH"}</span>
          <a href={`tel:${settings.phone || "+91-9861934840"}`} className="flex items-center gap-2 hover:text-[#ef2435]"><Phone size={11}/> {settings.phone || "+91 9861 934 840"}</a>
        </div>
      </div>

      {/* Main nav */}
      <header className={`sticky top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur border-b border-[#ececef] shadow-sm" : "bg-white"}`}>
        <div className="max-w-[1500px] mx-auto px-5 md:px-6 h-[92px] flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="https://customer-assets.emergentagent.com/job_duramix-preview/artifacts/v8jsk3w3_ssc_logo.png" alt="SSC" className="h-16 w-16 object-contain" />
            <div className="leading-none">
              <p className="font-display text-3xl text-gray-900 tracking-wide">SSC</p>
              <p className="text-[10px] tracking-[0.25em] text-gray-500 mt-1">READYMIX</p>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1 bg-[#f3f3f5] border border-[#ececef] rounded-full px-2 py-1.5">
            {LINKS.map(l => (
              <NavLink key={l.to} to={l.to} end={l.to==="/"} className={({isActive}) => `px-4 py-2 rounded-full text-[13px] font-medium transition-colors ${isActive ? "bg-[#ef2435] text-white" : "text-gray-700 hover:text-gray-900"}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link to="/contact" className="hidden md:inline-flex btn-primary px-5 py-2.5 rounded-full text-[13px] font-semibold">Get a quote</Link>
            <button className="lg:hidden p-2 text-gray-900" onClick={() => setOpen(!open)} aria-label="menu">
              {open ? <X size={24}/> : <Menu size={24}/>}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden bg-white border-t border-[#ececef]">
            <ul className="px-5 py-4 space-y-1">
              {LINKS.map(l => (
                <li key={l.to}>
                  <NavLink to={l.to} end={l.to==="/"} className={({isActive}) => `block py-3 px-3 rounded-lg text-sm font-medium ${isActive ? "bg-[#ef2435] text-white" : "text-gray-800"}`}>
                    {l.label}
                  </NavLink>
                </li>
              ))}
              <li className="pt-3"><Link to="/contact" className="btn-primary block w-full text-center py-3 rounded-full text-sm font-semibold">Get a quote</Link></li>
            </ul>
          </div>
        )}
      </header>
    </>
  );
}
